import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button, Label, Spinner } from "reactstrap";
import SwitchComponent from "../../../../components/switch/SwitchComponent";
 
const buildInitialForm = (v = {}) => ({
    ...v,
  project_name:     v.project_name     ?? "",
  is_pass_protected: v.is_pass_protected ?? false,
  password:         v.password         ?? "",
  confirm_password: v.confirm_password ?? "",
  enc_id:           v.enc_id           ?? "",
  pass_update:      0,
});
 
const FieldError = ({ msg }) =>
  msg ? <p className="text-danger mt-1 mb-0" style={{ fontSize: 12 }}>{msg}</p> : null;
 
const EditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 30 30" fill="none">
    <path d="M20.279 6.018c-.275.046-.519.137-.756.282-.252.16-1.594 1.488-1.685 1.663-.084.176-.084.374-.008.527.03.06.869.916 1.853 1.9 1.922 1.915 1.914 1.915 2.25 1.823.145-.038.305-.183.946-.824.617-.618.8-.832.907-1.045.167-.344.236-.687.205-1.053-.046-.633-.213-.877-1.38-2.037-.946-.938-1.137-1.083-1.533-1.182-.26-.069-.572-.092-.8-.054z" fill="currentColor"/>
    <path d="M16.473 9.33c-.199.098-9.42 9.352-9.587 9.619-.076.122-.175.328-.221.45-.099.298-.694 4.112-.664 4.257.046.183.259.343.434.343.244 0 3.821-.549 4.057-.626.603-.19.413-.007 5.454-5.05 4.103-4.104 4.736-4.745 4.774-4.898.1-.35.1-.35-1.806-2.265-.969-.968-1.823-1.792-1.892-1.83-.16-.077-.373-.077-.55 0z" fill="currentColor"/>
  </svg>
);

const PasswordSection = ({ formValues, errors, edit, onToggleEdit, onChange, initialValues }) => {
  if (!formValues.is_pass_protected) return null;

  return (
    <>
        <div> 
            <div className="project-auth-check-inputs edit  ">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <Label className="form-labels mb-0">
                        Password <span className="asterisk ml-1">*</span>
                    </Label> 
                </div>
                <input
                    className="form-control"
                    type="password"
                    name="password"
                    placeholder="Min. 6 characters"
                    readOnly={!edit}
                    value={formValues.password}
                    onChange={onChange}
                    autoComplete="new-password"
                />
                {formValues.is_pass_protected && initialValues.password && <button
                    type="button"
                    className={`btn btn-sm btn-primary ${edit ? "active" : ""}`}
                    style={{ padding: "4px 8px" }}
                    onClick={onToggleEdit}
                    title={edit ? "Lock field" : "Edit password"}
                >
                    <EditIcon />
                </button>}
            </div>
            <FieldError msg={errors.password} />
        </div>

        <div> 
            <div className="project-auth-check-inputs  ">
                <Label className="form-labels">
                Confirm password <span className="asterisk ml-1">*</span>
                </Label>
                <input
                className="form-control"
                type="password"
                name="confirm_password"
                placeholder="Re-enter password"
                readOnly={!edit}
                value={formValues.confirm_password}
                onChange={onChange}
                autoComplete="new-password"
                />
            </div>
            <FieldError msg={errors.confirm_password} />
        </div>
    </>
  );
};
 
const EditProjectModal = ({
  modal,
  toggle,
  initialValues = {},
  validationSchema,
  handleSubmitProject,
  loading = false,
  showpassfield = false,
}) => {
  const [formValues, setFormValues] = useState(() => buildInitialForm(initialValues));
  const [errors,     setErrors]     = useState({});
  const [edit,       setEdit]       = useState(false);
  const [dirty,       setIsdirty]   = useState(true);
 
  useEffect(() => {
    setFormValues(buildInitialForm(initialValues));
    setErrors({});
    setEdit(false); 
  }, [initialValues]);
 
  const handleChange = ({ target: { name, value } }) => {
    setIsdirty(false)
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setErrors((prev)     => ({ ...prev, [name]: "" }));
  };

  const handleSwitchChange = (checked) => {
    setErrors({});
    setFormValues((prev) => ({
      ...prev,
      is_pass_protected: checked,
      password:          checked ? (initialValues?.password ?? "") : "",
      confirm_password:  checked ? (initialValues?.confirm_password ?? "") : "",
      pass_update:       checked ? 1 : 0,
    }));
    if (!checked) {
      setEdit(false);
    } else if (!initialValues?.password) {
      setEdit(true);
    }
  };

  const handleToggleEdit = () => {
    setEdit((prev) => {
      const next = !prev;
      if (next) {
        setFormValues((f) => ({ ...f, password: "", confirm_password: "" }));
      }
      setFormValues((f) => ({ ...f, pass_update: next ? 1 : 0 }));
      return next;
    });
  };

  const handleCancel = () => {
    setFormValues(buildInitialForm(initialValues));
    setErrors({});
    setEdit(false);
    setIsdirty(true)
    toggle();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(formValues, { abortEarly: false });
      setErrors({});
      setEdit(false);
      handleSubmitProject(formValues);
    } catch (err) {
      const errMap = {};
      err?.inner?.forEach(({ path, message }) => { errMap[path] = message; });
      setErrors(errMap);
    }
  };
 
  const isEdit = Boolean(initialValues?.enc_id);

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      size="md"
      style={{ maxWidth: 600, zIndex: '999999 !important' }}
      centered
      zIndex={2001}
    >
      <form
        className="av-tooltip tooltip-label-bottom formGroups"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <ModalBody> 
          {!showpassfield && (
            <h5 className="f-w-600 mb-4" style={{ fontSize: 18 }}>
              {isEdit ? "Edit" : "Add New"} Project
            </h5>
          )}
 
          {!showpassfield && (
            <div className="mb-3">
              <Label className="form-labels">
                Project name <span className="asterisk">*</span>
              </Label>
              <input
                className="form-control"
                type="text"
                name="project_name"
                placeholder="Enter project name"
                value={formValues.project_name}
                onChange={handleChange}
                autoComplete="off"
              />
              <FieldError msg={errors.project_name} />
            </div>
          )}
 
          {showpassfield && (
            <div className="project-auth-check edit">
              <div className="d-flex align-items-center gap-3 mb-2">
                <Label className="form-labels mb-0">
                  Password protected?
                </Label>
                <SwitchComponent
                  checked={formValues.is_pass_protected}
                  onChange={handleSwitchChange}
                />
              </div>

              <PasswordSection
                formValues={formValues}
                errors={errors}
                edit={edit}
                onToggleEdit={handleToggleEdit}
                onChange={handleChange}
                initialValues = {initialValues}
              />
            </div>
          )}
 
          <div className="d-flex justify-content-end mt-4" style={{ gap: 10 }}>
            <Button
              color="secondary"
              className="btn btnCancel"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            
            <Button
              color="primary"
              type="submit"
              className="btn btn-primary"
              disabled={loading || (formValues.is_pass_protected && dirty)}
              style={{ minWidth: 72, position: "relative" }}
            >
              {loading ? (
                <Spinner size="sm" color="light" />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </ModalBody>
      </form>
    </Modal>
  );
};

export default EditProjectModal;